import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { addToCart } from "../data/actions/cart";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { URLDevelopment } from "../helpers/URL";

const Shop = () => {
  const dispatch = useDispatch();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [filters, setFilters] = useState({ category: "" });
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(1);
  const limit = 6;

  const [selectedOptions, setSelectedOptions] = useState({});
  //const [addingId, setAddingId] = useState(null);


  
 

  /* ================= FETCH ================= */
  useEffect(() => {
     const fetchProducts = async () => {
  try {
    const res = await axios.get(
      `${URLDevelopment}/api/product/list`,
      {
        params: {
          page,
          limit,
          category: filters.category,
          search: search,
        },
      }
    );

    console.log("API DATA:", res.data);

    setProducts(res.data.products);
  } catch (err) {
    console.error(err);
  }
};
    fetchProducts();
  }, [page, filters.category, search]);



  useEffect(() => {
    axios
      .get(`${URLDevelopment}/api/product/categories`)
      .then((res) => {
        console.log("CATEGORIES:", res.data);
        setCategories(res.data);
      })
      .catch(console.error);
  }, []);

  /* ================= PRICE ================= */
  const getFinalPrice = (p) => {
    if (p.isOnSale && p.discountPercent > 0) {
      return p.price - (p.price * p.discountPercent) / 100;
    }
    return p.price;
  };
const filteredProducts = products;
  /* ================= FILTER (SAFE) ================= */
  /*const filteredProducts = products.filter((p) => {
    
    if (!p) return false;

    // ✅ SAFE NAME
   // ✅ SAFE NAME
  const name = p.name ? p.name.toLowerCase() : "";
  const matchSearch = name.includes(search.toLowerCase());

  // ✅ FIX CATEGORY (MOST IMPORTANT)
  let productCategoryId = "";

  if (p.category) {
    if (typeof p.category === "object") {
      productCategoryId = p.category._id;
    } else {
      productCategoryId = p.category;
    }
  }

  const matchCategory = filters.category
    ? productCategoryId === filters.category
    : true;
    console.log("Product:", p.name);
console.log("Product Category:", p.category);
console.log("Selected Filter:", filters.category);

  return matchSearch && matchCategory;
});*/

  //console.log("FILTERED PRODUCTS:", filteredProducts);

  /* ================= UI ================= */
  return (
    <div className="min-h-screen bg-gray-50 px-6 py-8">
      <div className="max-w-7xl mx-auto">

        <h1 className="text-3xl font-bold mb-6">Clothing Store</h1>

        {/* FILTER */}
        <div className="bg-white p-4 rounded-xl shadow mb-6 flex gap-4">
          <input
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border px-3 py-2 rounded w-60"
          />

 <select
  value={filters.category}
  onChange={(e) => {
    console.log("SELECTED CATEGORY:", e.target.value); // ✅ DEBUG

    setFilters({
      ...filters,
      category: e.target.value,
    });
  }}
  className="border px-3 py-2 rounded"
>
  <option value="">All</option>
  {categories.map((c) => (
    <option key={c._id} value={c._id}>
      {c.name}
    </option>
  ))}
</select>
        </div>

        {/* PRODUCTS */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {filteredProducts.map((p) => {
            const selected = selectedOptions[p._id] || {};

            return (
              <div
                key={p._id}
                className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col h-[420px]"
              >
                {/* IMAGE */} 
                <Link to={`/product/${p._id}`}>
                  <div className="h-48 w-full overflow-hidden">
                    <img
                      src={p.photo}
                      alt={p.name || "product"}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </Link>

                {/* CONTENT */}
                <div className="flex flex-col justify-between flex-1 p-3">
                  <div>
                    <h3 className="font-semibold text-gray-800 line-clamp-2">
                      {p.name || "No Name"}
                    </h3>

                    <p className="font-bold mt-1">
                      ₹{getFinalPrice(p)}
                    </p>

                    {/* SIZE */}
                    <select
                      value={selected.size || ""}
                      onChange={(e) =>
                        setSelectedOptions((prev) => ({
                          ...prev,
                          [p._id]: {
                            ...prev[p._id],
                            size: e.target.value,
                            qty: prev[p._id]?.qty || 1,
                          },
                        }))
                      }
                      className="border mt-2 w-full text-sm"
                    >
                      <option value="">Size</option>
                      <option>S</option>
                      <option>M</option>
                      <option>L</option>
                      <option>XL</option>
                    </select>

                    {/* COLOR */}
                    <select
                      value={selected.color || ""}
                      onChange={(e) =>
                        setSelectedOptions((prev) => ({
                          ...prev,
                          [p._id]: {
                            ...prev[p._id],
                            color: e.target.value,
                            qty: prev[p._id]?.qty || 1,
                          },
                        }))
                      }
                      className="border mt-2 w-full text-sm"
                    >
                      <option value="">Color</option>
                      <option>Black</option>
                      <option>White</option>
                      <option>Blue</option>
                    </select>
                  </div>

                  {/* BUTTON */}
                  <button
                    type="button"
                    onClick={() => {
                      if (!selected.size || !selected.color) {
                        toast.error("Please select size & color");
                        return;
                      }

                      dispatch(
                        addToCart({
                          product: p._id,
                          name: p.name,
                          price: p.price,
                          finalPrice: getFinalPrice(p),
                          photo: p.photo,
                          size: selected.size,
                          color: selected.color,
                          quantity: selected.qty || 1,
                        })
                      );

                    
                      toast.success("Added to cart 🛒", {
  position: "top-center",
});
                    }}
                    className="mt-3 bg-blue-600 text-white py-2 rounded text-sm"
                  >
                    Add to Cart
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* PAGINATION */}
        <div className="flex justify-center mt-8 gap-4">
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Prev
          </button>

          <span className="px-4 py-2">Page {page}</span>

          <button
            onClick={() => setPage(page + 1)}
            className="px-4 py-2 bg-gray-300 rounded"
          >
            Next
          </button>
        </div>

      </div>
    </div>
  );
};

export default Shop;
